export default {
  methods: {
    getCurrentHostname() {
      const customHosts = ['Clipp360'];
      const { origin } = window.location;

      const match = customHosts.find((e) => {
        const target = e.toLowerCase().replace(/[^\w\s]/gi, '');
        return origin.indexOf(target) !== -1;
      });

      return match || 'ClippFácil';
    },
    setDocumentTitle(menus = [], route = {}) {
      if (route?.meta?.title) {
        document.title = `${route.meta.title} | ${this.getCurrentHostname()}`;
        return;
      }

      const setTitle = (menu) => {
        menu.forEach((current) => {
          if (current.children) {
            setTitle(current.children);
          }
          if (this.defaultRoute && current.uri === this.defaultRoute.submenu) {
            document.title = `${current.name} | ${this.getCurrentHostname()}`;
          }
        });
      };
      setTitle(menus);
    },
    goTo(base, link, v2 = false) {
      return v2 ? `/v2.html#/${base}/${link}/` : `/#/${base}/${link}/`;
    },
    link(base, link, v2 = false) {
      this.setDocumentTitle(this.menus, this.$route);
      return this.goTo(base, link, v2);
    },
    isActiveMenu(activeMenu = {}) {
      const { defaultRoute, menu, openMenu } = activeMenu;
      if (menu.identifier === openMenu) {
        return true;
      }

      return menu.children.find((item) => item.uri === defaultRoute.submenu);
    },
  },
};
